import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { ChangeDashboardOwnerDialogContent } from '@modules/dashboard/components/ChangeDashboardOwnerDialogContent';
import { GroupRounded } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { changeAnalysisOwnerFFlag } from 'v2/core/clients/featureFlag/flags';

interface ChangeDashboardOwnerMenuItemProps {
  closeMenu: () => void;
}

export const ChangeDashboardOwnerMenuItem = ({
  closeMenu,
}: ChangeDashboardOwnerMenuItemProps) => {
  const { openModal } = useMuiModalContext();

  const [, changeOwnerEnabled] = useFeatureFlag(changeAnalysisOwnerFFlag);

  if (!changeOwnerEnabled) {
    return null;
  }

  const openChangeDashboardOwnerDialog = () => {
    openModal({
      contentComponent: () => <ChangeDashboardOwnerDialogContent />,
      modalProps: {
        fullWidth: true,
        maxWidth: 'sm',
      },
    });
    closeMenu();
  };

  return (
    <MenuItem onClick={openChangeDashboardOwnerDialog}>
      <ListItemIcon>
        <GroupRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>Change Owner</ListItemText>
    </MenuItem>
  );
};
